﻿import { useEffect } from 'react';

import { GroupDetailsContext, GroupsContext } from 'pages/groups/context';
import { GMetrixLoader } from 'components/GMetrixLoader/GMetrixLoader';
import { NotificationContextProvider } from 'app/notifications';
import { type GroupPermissions } from 'pages/groups/types';
import { TabsContextProvider } from 'components/Tabs/Tabs';
import type { StudentPermissions } from 'pages/students';
import { GroupDetail } from 'pages/groups/GroupDetail';
import { useIntl } from 'react-intl';

// Tours temporarily disabled
// import { JoyrideContextProvider } from 'app/joyride';
import { DefaultLayout } from 'components/layout';
import { useParams } from 'react-router-dom';
import { Groups } from 'pages/groups/Groups';
import { PermissionsApi } from 'apis';
import { useSuperState } from 'hooks';

export type GroupsContextValue = {
    permissions: GroupPermissions;
    setStudentsWindow: (window: Window) => void;
    setTransactionsWindow: (window: Window) => void;
    studentPermissions: StudentPermissions;
    studentsWindow?: Window;
    transactionsWindow?: Window;
}

export const GroupsWrapper = () => {

    const { formatMessage } = useIntl();

    const [state, setState] = useSuperState({
        loading: true,
        permissions: null as GroupPermissions,
        studentPermissions: null as StudentPermissions,
        studentsWindow: undefined as Window | undefined,
        transactionsWindow: undefined as Window | undefined
    });

    const { loading, permissions, studentPermissions, studentsWindow, transactionsWindow } = state;

    const { id } = useParams();

    const setStudentsWindow = (window: Window) => setState({ studentsWindow: window });
    const setTransactionsWindow = (window: Window) => setState({ transactionsWindow: window });

    const fetchPermissions = async () => {

        try {

            const [permissions, studentPermissions] = await Promise.all([
                PermissionsApi.Get('Group'),
                PermissionsApi.Get('Student')
            ]);
            setState({
                loading: false,
                permissions,
                studentPermissions
            });

        } catch (e) {

            console.error(e);
            setState({ loading: false });

        }

    };

    useEffect(() => {

        fetchPermissions();

    }, []);

    const context: GroupsContextValue = {
        permissions,
        setStudentsWindow,
        setTransactionsWindow,
        studentPermissions,
        studentsWindow,
        transactionsWindow
    };

    return (
        <DefaultLayout pageTitle={formatMessage({ id: 'classrooms.e66138fb', defaultMessage: 'Classrooms' })}>
            <GroupsContext.Provider value={context}>
                <TabsContextProvider disableUrlSync context={GroupDetailsContext}>
                    {/* Tours temporarily disabled */}
                    {/* <JoyrideContextProvider> */}
                    <NotificationContextProvider>
                        {loading ?
                            (
                                <div className="d-flex justify-content-center align-items-center" style={{ height: 'calc(100vh - 70px)' }}>
                                    <GMetrixLoader />
                                </div>
                            )
                            :
                            (
                                id ? <GroupDetail /> : <Groups />
                            )
                        }
                    </NotificationContextProvider>
                    {/* </JoyrideContextProvider> */}
                </TabsContextProvider>
            </GroupsContext.Provider>
        </DefaultLayout>
    );

};